const paletteLibrary = {
	'default': {
		name: 'Default',
		premium: false,
		p: [
			'#ffffff', // white.
			'#999999', // gray.
			'#000000', // black.
			'#E06F8B', // meat.
			'#BE2633', // red.
			'#7a5226', // brown.
			'#EB8931', // orange.
			'#F7E26B', // yellow.
			'#A3CE27', // slimegreen.
			'#3d722c', // green.
			'#195d8a', // nightblue.
			'#31A2F2', // skyblue.
			'#B2DCEF', // cloudblue.
			'transparent', // ?
		]
	},
	'gray': {
		name: 'Grayscale',
		premium: false,
		p: [
			'#ffffff',
			'#dddddd',
			'#bbbbbb',
			'#999999',
			'#777777',
			'#555555',
			'#333333',
			'#111111',
			'#000000',
			'transparent',
		]
	},
	'classic': {
		name: 'Classic',
		premium: false,
		p: [
			'#ffffff', // white.
			'#999999', // gray.
			'#000000', // black.
			'#ff0000', // red.
			'#00FF00', // green.
			'#0000FF', // blue.
			'#FF00FF', // magenta.
			'#00FFFF', // cyan.
			'#FFFF00', // yellow.
			'transparent', // ?
		]
	},

	// https://creativemarket.com/Happyvector/3971906-Human-skin-tone-color-palette-set.#fullscreen
	'skin': {
		name: 'Skin Tone',
		premium: false,
		p: [
			'#f7ddc4',
			'#eed0b6',
			'#efc793',
			'#e7bc91',
			'#cb9662',
			'#ab8b64',
			'#b26949',
			'#94623d',
			'#885633',
			'#80492a',
			'#76441f',
			'#623a17',
			'#301e10',
			'transparent',
		]
	},

	'starry': {
		name: 'Starry',
		premium: true,
		credit: [ 'musthbly', 'https://lospec.com/palette-list/starry13' ],
		p: [
			'#4d456d',
			'#795389',
			'#a4628a',
			'#d38595',
			'#e9a7a3',
			'#f0d7b1',
			'#aec6a5',
			'#7ba1ab',
			'#657ba3',
			'#5a5f92',
			'#7d7db7',
			'#ad96cf',
			'#e6addd',
			'transparent',
		]
	},

	'pico8': {
		name: 'Pico 8',
		premium: true,
		credit: [ 'Pico-8 Console', 'https://www.lexaloffle.com/pico-8.php' ],
		p: [
			'#1D2B53',
			'#7E2553',
			'#008751',
			'#AB5236',
			'#5F574F',
			'#C2C3C7',
			'#FFF1E8',
			'#FF004D',
			'#FFA300',
			'#FFEC27',
			'#00E436',
			'#29ADFF',
			'#83769C',
			'#FF77A8',
			'#FFCCAA',
			'transparent',
		]
	},


	'final14': {
		name: 'Final 14',
		premium: true,
		credit: [ 'Final 14', 'https://lospec.com/palette-list/final-14' ],
		p: [
			'#ffdd84',
			'#ec955b',
			'#883a56',
			'#d95959',
			'#fc83c7',
			'#aa5ec3',
			'#443c7e',
			'#566ed0',
			'#7bb1eb',
			'#98eb77',
			'#3eca6b',
			'#49868b',
			'#10101d',
			'transparent',
		]
	},

	'pastel': {
		name: 'Pastel',
		premium: true,
		credit: [ 'Pikurā', 'https://lospec.com/palette-list/pastle-cute-minimal-lofi-colors' ],
		p: [
			'#92929c',
			'#a8b5ae',
			'#c5cfc4',
			'#cca3a3',
			'#f1b4b4',
			'#f3eded',
			'#e2e4df',
			'#96beb1',
			'#b9eedc',
			'#fbd4d2',
			'#eeb9c7',
			'#cac18a',
			'#e4dba0',
			'transparent',
		]
	},

	'sls08': {
		name: 'SLS08',
		premium: true,
		credit: [ 'Luis Miguel Maldonado', 'https://lospec.com/palette-list/slso8' ],
		p: [
			'#0d2b45',
			'#203c56',
			'#544e68',
			'#8d697a',
			'#d08159',
			'#ffaa5e',
			'#ffd4a3',
			'#ffecd6',
			'#ffffff',
			'transparent',
		]
	},

	'radioactive13': {
		name: 'Radioactive',
		premium: false,
		credit: [ 'Miguel Lucero', 'https://lospec.com/palette-list/radioactive13' ],
		p: [
			'#422c33',
			'#73514d',
			'#ac8a71',
			'#decb9f',
			'#52615d',
			'#7f8f81',
			'#bfc7af',
			'#eeecde',
			'#2a3a42',
			'#4d6476',
			'#7895ab',
			'#a8cfda',
			'#1f1a24',
			'transparent',
		]
	},

	'lucky13': {
		name: 'Lucky',
		premium: true,
		credit: [ 'SalamiChild', 'https://lospec.com/palette-list/lucky-13' ],
		p: [
			'#3a3a3a',
			'#6b6b6c',
			'#a8a8a8',
			'#e0eceb',
			'#aed0ed',
			'#888ff1',
			'#a9d71e',
			'#5aac1d',
			'#2e6b1c',
			'#ab7520',
			'#f4a30c',
			'#d9322a',
			'#ec548e',
			'transparent',
		]
	},



	'tyarcanixium13': {
		name: 'Arcanixium',
		premium: true,
		credit: [ 'Toby_Yasha', 'https://lospec.com/palette-list/ty-arcanixium-13' ],
		p: [
			'#f2f1d6',
			'#84bab4',
			'#6577aa',
			'#754a6d',
			'#ca958c',
			'#9f714a',
			'#605951',
			'#8f442f',
			'#4a3535',
			'#8f974a',
			'#50653e',
			'#324545',
			'#2a2629',
			'transparent',
		]
	},

	'fadednature13': {
		name: 'Faded Nature',
		premium: true,
		credit: [ 'ShinyTseul', 'https://lospec.com/palette-list/faded-nature-13' ],
		p: [
			'#66382e',
			'#2d4d26',
			'#5d804d',
			'#b3955a',
			'#995c3d',
			'#992e2e',
			'#383159',
			'#394c73',
			'#4d7f99',
			'#adbdcc',
			'#828499',
			'#5c5766',
			'#19161a',
			'transparent',
		]
	},

	'robotic': {
		name: 'Robotic',
		premium: false,
		credit: [ 'Floatingtable Studios', 'https://lospec.com/palette-list/robotic' ],
		p: [
			'#1d0f1d',
			'#342537',
			'#3c3748',
			'#4b5162',
			'#5f667b',
			'#708393',
			'#3b1716',
			'#8a3b06',
			'#fadd93',
			'#d4ad6a',
			'#c02811',
			'#f6a79b',
			'#f7f7f4',
			'transparent',
		]
	},

	'hydrangea11': {
		name: 'Hydrangea',
		premium: true,
		credit: [ `Dinchen\'s Art`, 'https://lospec.com/palette-list/hydrangea-11' ],
		p: [
			'#413652',
			'#6f577e',
			'#986f9c',
			'#c090a7',
			'#d4beb8',
			'#eae4dd',
			'#c9d4b8',
			'#90c0a0',
			'#6f919c',
			'#62778c',
			'#575f7e',
			'transparent',
		]
	},

	'70szine': {
		name: '70s Zine',
		premium: true,
		credit: [ 'Polyducks', 'https://lospec.com/palette-list/70s-zine' ],
		p: [
			'#1e1610',
			'#d3ad8b',
			'#fcce8d',
			'#f3ede3',
			'#f95142',
			'#ff8f46',
			'#f2bb4e',
			'#84a3a5',
			'#4d7c71',
			'#405987',
			'#1f2f49',
			'transparent',
		]
	},

	'sherbertshark': {
		name: 'Shark',
		premium: false,
		credit: [ 'Polyducks', 'https://lospec.com/palette-list/sherbert-shark' ],
		p: [
			'#dde4e8',
			'#ffc97a',
			'#8dc196',
			'#5a6e93',
			'#301c44',
			'#ce2f7f',
			'#ef8a6e',
			'#514cad',
			'#877aff',
			'transparent',
		]
	},

	// '': {
	// 	name: '',
	// 	premium: true,
	// credit: [ '', '' ],
	// 	p: [
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'',
	// 		'transparent',
	// 	]
	// },

};


let settingsPalette = paletteLibrary.default.p;
